export default function AboutSection() {
  return (
    <section className="relative w-full bg-background-100 py-28 md:py-36 px-10 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-16">
          <div className="lg:w-2/5 flex-shrink-0">
            <span className="text-xs text-foreground-500 font-label tracking-wider">
              / About
            </span>
          </div>

          <div className="lg:w-3/5">
            <p className="text-2xl md:text-[30px] font-light text-foreground-800 leading-[1.7] font-body">
              A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. The team builds scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
            </p>

            <p className="mt-8 text-2xl md:text-[30px] font-light text-foreground-800 leading-[1.7] font-body">
              The practice follows modern software engineering principles including clean architecture, performance optimization, and user-centered design. Continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards ensure the delivery of reliable and future-ready IT solutions.
            </p>

            <div className="mt-20 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2.5">
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                </div>
              </div>
              <span className="text-[13px] text-foreground-600 font-label tracking-wide">
                Focused on iOS Engineering Discipline
              </span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-background-300/50">
          <div className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
            <span className="text-[11px] text-foreground-500 font-label tracking-wider uppercase">
              Established Technical Excellence
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}